module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img68.607ae201.jpg";